import React from 'react';

import { promoGradientEnd, promoGradientStart } from 'common/components/settings/referrals/process';

import useTheme from 'lib/hooks/useTheme';

type Props = {
  className?: string;
};

export const TicketSVG = ({ className }: Props) => {
  const theme = useTheme();

  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 223 132" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0C1.79086 0 0 1.79086 0 4V22C5.52285 22 10 26.4772 10 32C10 37.5228 5.52285 42 0 42V56C5.52285 56 10 60.4772 10 66C10 71.5228 5.52285 76 0 76V91C5.52285 91 10 95.4771 10 101C10 106.523 5.52285 111 0 111V128C0 130.209 1.79087 132 4.00001 132H219C221.209 132 223 130.209 223 128V111C217.477 111 213 106.523 213 101C213 95.4771 217.477 91 223 91V76C217.477 76 213 71.5228 213 66C213 60.4772 217.477 56 223 56V42C217.477 42 213 37.5228 213 32C213 26.4772 217.477 22 223 22V4C223 1.79086 221.209 0 219 0H4Z"
        fill="url(#ticket-svg-gradient)"
        filter="url(#ticket-svg-shadow)"
      />
      <defs>
        <linearGradient
          id="ticket-svg-gradient"
          x1="0.000384569"
          y1="-31.0477"
          x2="163.673"
          y2="154.105"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={promoGradientStart({ theme })} />
          <stop offset="1" stopColor={promoGradientEnd({ theme })} />
        </linearGradient>
      </defs>
    </svg>
  );
};
